import * as Sentry from '@sentry/vue';
import type { App } from 'vue';

interface SetupSentryOptions {
    dsn?: string;
    environment?: string;
    release?: string;
    appName?: string;
    extraTags?: Record<string, string>;
    userId?: string | number;
}

interface SentryInfo {
    release?: string;
    environment?: string;
    user?: {
        id: string | number;
        username: string;
        email: string;
    };
}

declare global {
    interface Window {
        sentryInfo?: SentryInfo;
    }
}

export function setupSentry(app: App<Element>, options: SetupSentryOptions = {}) {
    const {
        dsn = import.meta.env.VITE_SENTRY_DSN_ADMIN,
        environment = window.sentryInfo?.environment ?? import.meta.env.APP_ENV ?? 'local',
        release = window.sentryInfo?.release,
        appName = import.meta.env.VITE_SENTRY_APP_NAME_ADMIN ?? 'frontend',
        extraTags = {},
        userId,
    } = options;

    if (!dsn) {
        console.warn('[Sentry] DSN not provided – skipping init');
        return;
    }

    Sentry.init({
        app,
        dsn,
        environment,
        release,
    });

    const scope = Sentry.getCurrentScope();

    scope.setTag('app_name', appName);
    scope.setTag('hostname', window.location.hostname);

    for (const [key, value] of Object.entries(extraTags)) {
        scope.setTag(key, value);
    }

    if (userId) {
        scope.setUser({ id: String(userId) });
    }

    if (window.sentryInfo && window.sentryInfo.user) {
        scope.setUser({
            id: String(window.sentryInfo.user.id),
            username: window.sentryInfo.user.username,
            email: window.sentryInfo.user.email,
        });
    }
}
